export default __webpack_public_path__ + "static/free-trial-img-6b7fe8b87759ee253769225ecd0c6b37.png";